import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { XCircleIcon } from 'lucide-react';
export function FailedAttempts() {
  const attempts = [{
    title: 'El cardio intenso (HIIT/Correr)',
    desc: 'Eleva aún más tu cortisol, inflamándote más. Tu cuerpo lo interpreta como más estrés.'
  }, {
    title: 'Las dietas de 1,200 calorías',
    desc: "Le dicen a tu cerebro que hay 'escasez', obligándolo a retener grasa visceral para sobrevivir."
  }, {
    title: "Los suplementos 'quemadores'",
    desc: 'Solo aceleran tu sistema nervioso ya agotado, empeorando la fatiga adrenal.'
  }, {
    title: 'Consejos de influencers de 20 años',
    desc: 'No tienen tus responsabilidades, tu nivel de estrés, ni tus cambios hormonales.'
  }];
  return <section className="py-24 bg-white" data-id="element-13">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <FadeIn data-id="element-15">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-16">
            ¿Por qué lo que has intentado NO funciona?
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-17">
          {attempts.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-18">
              <div className="flex items-start p-6 rounded-2xl bg-cream border border-sage-light/50 hover:border-sage transition-colors duration-300 h-full" data-id="element-19">
                <XCircleIcon className="w-8 h-8 text-red-400/80 shrink-0 mr-4 mt-1" data-id="element-20" />
                <div data-id="element-21">
                  <h3 className="text-lg font-bold mb-2" data-id="element-22">{item.title}</h3>
                  <p className="text-brown/70 leading-relaxed" data-id="element-23">{item.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}